import { renderToString, h, Fragment, cn } from '../../../lib/vdom.js';

export type NavbarLink = {
  label: string;
  href: string;
  primary?: boolean;
};

export default function Navbar(props: { breadcrumb?: NavbarLink; links: NavbarLink[]; transparentAtTop?: boolean }) {
  return (
    <nav id="navbar" className={cn('at-top', props.transparentAtTop && 'transparent-at-top')}>
      <div className="content-wrapper">
        <div className="content">
          <Logo />
          <Breadcrumb link={props.breadcrumb} />
          <ul className="links">
            {props.links.map(link => (
              <li className={link.primary ? 'primary' : ''}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export function initNavbar() {
  const THRESHOLD_1 = 300;
  const THRESHOLD_2 = 400;
  const navbar = document.getElementById('navbar')!;
  navbar.classList.toggle('at-top', window.scrollY < THRESHOLD_1);
  document.addEventListener('scroll', scrolled);
  // navbar.classList.toggle('initialized', true);

  function scrolled() {
    if (window.scrollY > THRESHOLD_2) {
      navbar.classList.toggle('at-top', false);
    } else if (window.scrollY < THRESHOLD_1) {
      navbar.classList.toggle('at-top', true);
    }
  }
}

export function Logo() {
  const href = process.env.NODE_ENV === 'development' ? '/' : 'https://computing-den.com';
  return (
    <a href={href} className="logo">
      Computing Den
    </a>
  );
}

export function Breadcrumb(props: { link?: NavbarLink }) {
  const { link } = props;
  if (!link) return null;

  return (
    <div>
      <span className="logo-breadcrumb-separator">|</span>
      <a
        href={link.href}
        className="breadcrumb"
        // onClick={e => scrollToTopIfOnSamePage(e, link.href)}
      >
        {link.label}
      </a>
    </div>
  );
}
